import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '@/shared/ui/elements';

import { PillLabelStyled } from './PillLabel.styled';

const PillLabel = ({ content }) => (
  <PillLabelStyled>
    <Text content={content} />
  </PillLabelStyled>
);

PillLabel.propTypes = {
  content: PropTypes.string,
};

PillLabel.defaultProps = {
  content: '',
};

export default PillLabel;
